import { select } from '@ps/web-core-store';

import { getApolloClient } from '@swf/core/providers/ApolloClientProvider';
import store from '@swf/core/store';

const createNotificationServiceClient = () => {
  const { getState } = store;
  const state = getState();

  const { apiDomain = '' } = select.config.get(state);

  const wsUrl = new URL(apiDomain);
  wsUrl.protocol = 'wss';
  wsUrl.pathname = wsUrl.pathname.replace(/\/$/, '') + '/pam/notifications/subscription';

  const httpUrl = new URL(apiDomain);
  httpUrl.pathname = httpUrl.pathname.replace(/\/$/, '') + '/pam/notifications/graphql';

  const client = getApolloClient({
    httpLinkUri: httpUrl.href,
    wsLinkUrl: wsUrl.href,
    useIdpAuth: true
  });

  return client;
};

export default createNotificationServiceClient;
